import Filter from './Filter'

export { Filter } from './Filter'
export default Filter;


// WEBPACK FOOTER //
// ./src/components/Filter/index.js